/**
 * Enlaces cuyo destino todavía no existe.
 *
 * La landing está publicada antes que el portal, así que todos los CTA apuntan
 * a rutas que aún no responden. En vez de dejar que el usuario caiga en un 404
 * —la peor primera impresión posible para un producto legal— el clic se
 * intercepta y se muestra el aviso de `comingSoon`.
 *
 * La lista de rutas pendientes vive en src/content/site.ts, no aquí: el día que
 * el portal entre en producción se edita el contenido y ningún componente
 * cambia.
 */
import { pendingRoutes } from '../content/site';

const PENDING = new Set<string>(pendingRoutes);

export function isPending(href: string): boolean {
  const trimmed = href.trim();

  /*
   * `#` a secas es el marcador de los badges de App Store / Google Play: las
   * apps no están publicadas. Ojo — no confundir con `#seccion`, que son las
   * anclas de la propia landing y sí navegan.
   */
  if (trimmed === '#') return true;

  return PENDING.has(trimmed);
}
